var _path, _g, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaved2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1854_3815",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 27,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 0.75H26.0906V25.1262H0.5V0.75Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1854_3815)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.77964 12.1539C4.53214 17.6064 11.4559 22.0152 13.2959 23.1064C15.1421 22.0039 22.1159 17.5464 23.8121 12.1589C24.9259 8.67641 23.8921 4.26516 19.7846 2.94141C17.7946 2.30266 15.4734 2.69141 13.8709 3.93141C13.5359 4.18891 13.0709 4.19391 12.7334 3.93891C11.0359 2.66266 8.81839 2.28891 6.79714 2.94141C2.69589 4.26391 1.66589 8.67516 2.77964 12.1539ZM13.2971 25.1264C13.1421 25.1264 12.9884 25.0889 12.8484 25.0126C12.4571 24.7989 3.24089 19.7189 0.994641 12.7264C0.993391 12.7264 0.993391 12.7251 0.993391 12.7251C-0.416609 8.32265 1.15339 2.79015 6.22214 1.1564C8.60214 0.386398 11.1959 0.725148 13.2934 2.0489C15.3259 0.763898 18.0259 0.408898 20.3584 1.1564C25.4321 2.79265 27.0071 8.3239 25.5984 12.7251C23.4246 19.6376 14.1409 24.7939 13.7471 25.0101C13.6071 25.0876 13.4521 25.1264 13.2971 25.1264Z",
    fill: "#BDBDBD"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6921 10.2813C20.2084 10.2813 19.7984 9.91009 19.7584 9.42009C19.6759 8.39259 18.9884 7.52509 18.0096 7.20884C17.5159 7.04884 17.2459 6.52009 17.4046 6.02884C17.5659 5.53634 18.0896 5.26884 18.5846 5.42384C20.2884 5.97509 21.4821 7.48384 21.6284 9.26759C21.6696 9.78384 21.2859 10.2363 20.7696 10.2776C20.7434 10.2801 20.7184 10.2813 20.6921 10.2813Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaved2);
export default __webpack_public_path__ + "static/media/saved2.aa21cb9976b8d754035b37de4460535d.svg";
export { ForwardRef as ReactComponent };